export default {
    parts: [
        'container',
        'priceSet',
        'currentPrice',
        'currentPricePromo',
        'currentPriceRange',
        'listPrice',
        'listPriceRange',
        'quantityText'
    ],
    baseStyle: {
        container: {
            marginBottom: {base: 1, lg: 0}
        },
        priceSet: {
            alignItems: 'center',
            gap: 2
        },
        currentPrice: {
            color: 'webTypo.textPrimary',
            textStyle: 'labelXs'
        },
        currentPricePromo: {
            color: 'webTypo.textSale',
            textStyle: 'labelXs'
        },
        currentPriceRange: {
            textStyle: 'labelXs'
        },
        listPrice: {
            color: 'webTypo.textStrikethrough',
            textStyle: 'labelXs'
        },
        listPriceRange: {
            color: 'webTypo.textStrikethrough',
            textStyle: 'labelXs'
        },
        quantityText: {
            textStyle: 'bodyXsSRegular'
        }
    }
}
